// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"022e4bc6","239":"c74a44a5","453":"81323002","455":"98ee9109"}[chunkId] + ".chunk.js";
};